import { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { useCommonContext } from "../../../utils/context";

const AddAMCModal = ({ show, handleClose, amcData, fetchAmcData }) => {
  const [underWarranty, setUnderWarranty] = useState(true);
  const [selectedBrandName, setSelectedBrandName] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    amcName: "",
    activationTime: "",
    activationDate: "",
    no_of_service: "",
    // remainder: "Normal",
    productBrand: "",
    brand: "",
    serialModelNo: "",
    serviceAmount: "",
    receivedAmount: "",
    customer: "",
    select_service_occurence: "",
    status: "Upcoming",
    note: "",
  });

  const { fetchCustomers, customers, isloading, brandNames, setBrandNames } =
    useCommonContext();

  const resetForm = () => {
    setFormData({
      amcName: "",
      activationTime: "",
      activationDate: "",
      no_of_service: 12,
      // remainder: "",
      productBrand: "",
      brand: "",
      serialModelNo: "",
      serviceAmount: "",
      receivedAmount: "",
      customer: "",
      select_service_occurence: "Monthly",
      status: "Upcoming",
      note: "",
    });
  };

  useEffect(() => {
    if (amcData) {
      setUnderWarranty(amcData.underWarranty || true);
      setFormData({
        amcName: amcData.amcName || "",
        activationTime: amcData.activationTime || "",
        activationDate: amcData.activationDate || "",
        no_of_service: amcData.no_of_service || "",
        // remainder: amcData.remainder || "",
        productBrand: amcData.productBrand || "",
        serialModelNo: amcData.serialModelNo || "",
        serviceAmount: amcData.serviceAmount || "",
        receivedAmount: amcData.receivedAmount || "",
        customer: amcData.customer ? amcData.customer.id : "",
        select_service_occurence: amcData.select_service_occurence || "",
        status: amcData.status || "Upcoming",
        note: amcData.note || "",
      });

      const selectedCustomerData = customers.find(
        (customer) => customer.id === amcData.customer?.id,
      );
      if (selectedCustomerData) {
        setSelectedCustomer({
          value: selectedCustomerData.id,
          label: selectedCustomerData.customer_name,
        });
        if (selectedCustomerData.brand_names) {
          setBrandNames(
            selectedCustomerData.brand_names.map((brand) => ({
              value: { id: brand.id, name: brand.name },
              label: brand.name,
            })),
          );
        }
      }

      setSelectedBrandName(
        amcData.brand
          ? {
              value: { id: amcData.brand.id, name: amcData.brand.name },
              label: amcData.brand.name,
            }
          : null,
      );
    } else {
      resetForm();
      setSelectedCustomer(null);
      setBrandNames([]);
      setSelectedBrandName(null);
    }
  }, [amcData, show, customers]);

  const handleWarrantyChange = (value) => {
    setUnderWarranty(value);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    if (
      parseFloat(formData.receivedAmount) > parseFloat(formData.serviceAmount)
    ) {
      toast.error("Received amount should not be greater than service amount.");
      return;
    }

    setLoading(true);
    const amcDetails = {
      ...formData,
      brand: selectedBrandName?.value?.id || formData.brand,
      underWarranty,
    };

    try {
      let response;
      if (amcData) {
        response = await axios.put(
          `${BASE_URL}/api/amcs/${amcData.id}/`,
          amcDetails,
          { headers: HEADERS },
        );
        toast.success(response.data.message || "AMC updated successfully.");
      } else {
        response = await axios.post(`${BASE_URL}/api/amcs/`, amcDetails, {
          headers: HEADERS,
        });
        toast.success(response.data.message || "AMC added successfully.");
      }
      handleClose();
      fetchAmcData();
    } catch (error) {
      if (error.response?.data?.error) {
        toast.error(error.response.data.message || error.response.data.error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "select_service_occurence") {
      const serviceMap = {
        Monthly: 12,
        Quarterly: 4,
        "Half Year": 2,
        Yearly: 1,
      };

      setFormData((prevData) => ({
        ...prevData,
        select_service_occurence: value,
        no_of_service: serviceMap[value], // auto set
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const getServiceOptions = () => {
    switch (formData.select_service_occurence) {
      case "Monthly":
        return 12;
      case "Quarterly":
        return 4;
      case "Half Year":
        return 2;
      case "Yearly":
        return 1;
      default:
        return "";
    }
  };

  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomer(selectedOption);

    setFormData((prevData) => ({
      ...prevData,
      customer: selectedOption?.value || "",
    }));

    const selectedCustomerData = customers.find(
      (customer) => customer.id === selectedOption?.value,
    );

    if (selectedCustomerData?.brand_names) {
      setBrandNames(
        selectedCustomerData.brand_names.map((brand) => ({
          value: { id: brand.id, name: brand.name },
          label: brand.name,
        })),
      );
    } else {
      setBrandNames([]);
    }
    setSelectedBrandName(null);
  };

  const handleBrandNameChange = (selectedOption) => {
    setSelectedBrandName(selectedOption);
    setFormData((prevData) => ({
      ...prevData,
      brand: selectedOption?.value?.id || "",
    }));
  };

  const customerOptions = customers.map((customer) => ({
    value: customer.id,
    label: customer.customer_name,
  }));

  return (
    <Modal
      show={show}
      onHide={() => {
        resetForm();
        handleClose();
        setSelectedCustomer(null);
        setBrandNames([]);
        setSelectedBrandName(null);
      }}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="w-100 ">
          {amcData ? "Edit AMC" : "Add AMC"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 className="mb-4">AMC Details</h5>
        <Form onSubmit={handleFormSubmit}>
          <Row className="">
            <Col>
              <Form.Floating controlId="amcName">
                <Form.Control
                  type="text"
                  placeholder="Enter AMC Name"
                  value={formData.amcName}
                  name="amcName"
                  className="mb-3"
                  onChange={handleChange}
                  required
                />
                <Form.Label>AMC Name*</Form.Label>
              </Form.Floating>
            </Col>
            <Col>
              <Form.Floating controlId="activationTime">
                <Form.Control
                  type="time"
                  placeholder="Activation Time"
                  value={formData.activationTime}
                  name="activationTime"
                  className="mb-3"
                  onChange={handleChange}
                  required
                />
                <Form.Label>Activation Time*</Form.Label>
              </Form.Floating>
            </Col>
            <Col>
              <Form.Floating controlId="activationDate">
                <Form.Control
                  type="date"
                  placeholder="Activation Date"
                  value={formData.activationDate}
                  name="activationDate"
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
                <Form.Label>Activation Date*</Form.Label>
              </Form.Floating>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Floating controlId="select_service_occurence">
                <Form.Select
                  value={formData.select_service_occurence}
                  name="select_service_occurence"
                  required
                  onChange={handleChange}
                >
                  <option value="Monthly">Monthly</option>
                  <option value="Quarterly">Quarterly</option>
                  <option value="Half Year">Half Year</option>
                  <option value="Yearly">Yearly</option>
                </Form.Select>
                <Form.Label>Service Occurence*</Form.Label>
              </Form.Floating>
            </Col>

            <Col>
              <Form.Floating controlId="no_of_service">
                <Form.Select
                  value={formData.no_of_service}
                  name="no_of_service"
                  onChange={handleChange}
                  required
                  disabled={!formData.select_service_occurence}
                >
                  {formData.select_service_occurence && (
                    <option value={getServiceOptions()}>
                      {getServiceOptions()}
                    </option>
                  )}
                </Form.Select>

                <Form.Label>No. of Service*</Form.Label>
              </Form.Floating>
            </Col>

          
          </Row>

          {amcData && (
            <Row className="mb-3">
              <Col>
                <Form.Floating controlId="status">
                  <Form.Select
                    value={formData.status}
                    name="status"
                    onChange={handleChange}
                  >
                    <option value="Completed">Completed</option>
                    <option value="Upcoming">Upcoming</option>
                    <option value="Renewal">Renewal</option>
                    <option value="Expired">Expired</option>
                  </Form.Select>
                  <Form.Label>Select Status</Form.Label>
                </Form.Floating>
              </Col>
            </Row>
          )}

          <Row className="mb-3">
            <Col>
              <Form.Floating controlId="serialModelNo">
                <Form.Control
                  type="text"
                  placeholder="Serial Model No"
                  value={formData.serialModelNo}
                  // required
                  name="serialModelNo"
                  onChange={handleChange}
                />
                <Form.Label>Serial Model No</Form.Label>
              </Form.Floating>
            </Col>
            <Col>
              <Form.Floating controlId="serviceAmount">
                <Form.Control
                  type="number"
                  step="0.01"
                  placeholder="Service Amount"
                  value={formData.serviceAmount}
                  name="serviceAmount"
                  // required
                  onChange={handleChange}
                />
                <Form.Label>Service Amount</Form.Label>
              </Form.Floating>
            </Col>
            <Col>
              <Form.Floating controlId="receivedAmount">
                <Form.Control
                  type="number"
                  step="0.01"
                  placeholder="Received Amount"
                  value={formData.receivedAmount}
                  // required
                  name="receivedAmount"
                  onChange={handleChange}
                />
                <Form.Label>Received Amount</Form.Label>
              </Form.Floating>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Floating controlId="customer" style={{ width: "100%" }}>
                <Select
                  options={customerOptions}
                  value={selectedCustomer}
                  onChange={handleCustomerChange}
                  required
                  placeholder="Customer Name*"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                      borderRadius: "5px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      justifyContent: "flex-start",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 100,
                      marginTop: "5px",
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,
                      textAlign: "left",
                      padding: "10px 15px",
                    }),
                  }}
                />
              </Form.Floating>
            </Col>
          </Row>
          {brandNames?.length > 0 && (
            <Row className="mb-3">
              <Col>
                <div className="form-group">
                  <Select
                    id="brand"
                    name="brand"
                    placeholder="Product Name"
                    options={brandNames}
                    value={selectedBrandName}
                    onChange={handleBrandNameChange}
                    isClearable
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "40px",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        justifyContent: "flex-start",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 100,
                        marginTop: "5px",
                      }),
                      option: (base, { isFocused }) => ({
                        ...base,
                        textAlign: "left",
                        padding: "10px 15px",
                      }),
                    }}
                  />
                </div>
              </Col>
              <Col>
                <Form.Floating controlId="productBrand">
                  <Form.Control
                    type="text"
                    placeholder="Product Brand"
                    value={formData.productBrand}
                    name="productBrand"
                    onChange={handleChange}
                  />
                  <Form.Label>Product Brand</Form.Label>
                </Form.Floating>
              </Col>
            </Row>
          )}

          <Row className="mb-3">
            <Col>
              <Form.Floating controlId="note">
                <Form.Control
                  type="text"
                  placeholder="Note"
                  value={formData.note}
                  name="note"
                  onChange={handleChange}
                />
                <Form.Label>Note</Form.Label>
              </Form.Floating>
            </Col>
          </Row>

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Close
            </Button>

            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                </>
              ) : amcData ? (
                "Submit"
              ) : (
                "Submit"
              )}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddAMCModal;
